const KEY = "pf.deviceId";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
let memory: string | undefined;

/**
 * A random id for this desktop install, sent at sign-in so the server recognises the device
 * and skips the "new sign-in" mail. Browsers get a cookie from the server instead.
 */
export function desktopDeviceId(): string {
  try {
    const stored = window.localStorage.getItem(KEY);
    if (stored !== null && UUID.test(stored)) {
      return stored;
    }
    const id = memory ?? crypto.randomUUID();
    window.localStorage.setItem(KEY, id);
    memory = id;
    return id;
  } catch {
    memory = memory ?? crypto.randomUUID();
    return memory;
  }
}
